import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_helper } from "Ressources/dbh_helper";

export class OrganigramHelper {

    constructor(organigramInfo: OrganigramInfos) {
        this._organigramInfo = organigramInfo;
    }

    private _organigramInfo: OrganigramInfos;

    public static GridTileSize: number = 75;
    public InitEditOrganigram = ($container: JQuery<HTMLElement>, organigram: OrganigramInfos) => {

        let curOrgInfo: OrganigramInfos;
        const orgIsFromFile = OrganigramHelper.checkOrganigramIsFromJsonFile(organigram);

        /*Wenn bereits ein gespeichertes Organigram existiert, wird dieses genutzt*/
        if (!orgIsFromFile) {
            curOrgInfo = this._organigramInfo;
        }
        else {
            this._organigramInfo = organigram;
            curOrgInfo = organigram;
        }

        /*Class-Names*/
        const rasterContainerCssName = 'org-raster-container';
        const rasterContentCssName = 'org-raster-content';
        const rasterColCssName = 'org-raster-col';
        const rasterRowCssName = 'org-raster-row';

        renderHtml();
        for (let i = 0; i < this._organigramInfo.Bubbles.length; i++) {
            OrganigramHelper.renderLine(this._organigramInfo.Bubbles[i], this._organigramInfo, 'org-raster-content');
        }

        /* Laden des Htmls für Daten aus Datei*/
        if (orgIsFromFile) {
            for (let i = 0; i < curOrgInfo.Bubbles.length; i++) {
                const bubble = curOrgInfo.Bubbles[i];
                const parameters = [];
                parameters.push(['top', bubble.top]);
                parameters.push(['left', bubble.left]);
                parameters.push(['headline', bubble.headline]);
                parameters.push(['info', bubble.info]);

                for (let j = 0; j < bubble.users.length; j++) {
                    parameters.push(['adressen', bubble.users[j]]);
                }

                parameters.push(['color', bubble.color]);
                parameters.push(['isSmallBubble', bubble.isSmall]);

                sendAddBubbleRequest(parameters, bubble.top, bubble.left, (response) => {

                    /*Erstelle Bubble an angegebener Position*/
                    const newBubble = OrganigramHelper.createNewHtmlBubble(response.toString(), curOrgInfo, bubble.id, bubble.top, bubble.left);
                    $(`.${rasterContentCssName}`).append(newBubble);
                }, () => { });
            }
        }

        /*Event-Zuweisung*/
        /*###############*/
        /*Neue Bubble erstellen und im Html hinzufügen*/
        $(`#addBubbleBtn`).on(`click`, function () {
            var form = dbh_helper.findNearestForm($('#Info'));
            /* zukünftige, initialle Position der Bubble ermitteln*/
            const top = $("#Top").val();
            const left = $("#Left").val();
            const parameters: any[] = dbh_helper.getParameterArrayForForm(form);

            sendAddBubbleRequest(parameters, +top, +left, (response) => {
                /*Neue Nummer für Bubble-id bestimmen
                     * .map liefert ein neues Array (hier: mit den aktuellen Ids der Bubbles)
                     * ...[a,b,c] -> Spread-Operator, Elemente des Arrays werden als einzelne Elemente zurückgegeben
                     */
                let nextId: number = curOrgInfo.Bubbles.length === 0 ? 0 : Math.max(...curOrgInfo.Bubbles.map(b => b.id)) + 1;
                /*Bubble-Informationen zu Info-Array hinzufügen*/
                curOrgInfo.Bubbles.push(OrganigramHelper.createBubbleInfoItem(parameters, nextId));

                /*Erstelle Bubble an angegebener Position*/
                const newBubble = OrganigramHelper.createNewHtmlBubble(response.toString(), curOrgInfo, nextId, +top, +left);
                $(`.${rasterContentCssName}`).append(newBubble);

                OrganigramHelper.closeAndClearAddBubblePopup();
            }, () => { OrganigramHelper.closeAndClearAddBubblePopup(); });
        });

        /*Bubble bearbeiten und im Html updaten*/
        $(`#editBubbleBtn`).on(`click`, function () {
            var form = dbh_helper.findNearestForm($('#Info'));
            /* Position der Bubble ermitteln*/
            const top = $("#Top").val();
            const left = $("#Left").val();

            const id: number = +$("#ID").val();
            const parameters: any[] = dbh_helper.getParameterArrayForForm(form);

            dbh_helper.SendGetRequest(
                'GetNewBubbleHtml', 'booklet/organigram',
                parameters,
                null, (response) => {
                    /*Bubble im Data-Set aktualisieren*/
                    OrganigramHelper.editBubbleInfoItem(curOrgInfo.Bubbles, id, parameters)

                    /* Neues Html erstellen, altes Html löschen, neues Html hinzufügen */
                    const newBubble = OrganigramHelper.createNewHtmlBubble(response.toString(), curOrgInfo, id, +top, +left);
                    $(`.outerBubble[data-bubbleid='${id}']`).remove()
                    $(`.${rasterContentCssName}`).append(newBubble);
                    OrganigramHelper.closeAndClearAddBubblePopup();
                },
                /* OnError */
                () => {
                    OrganigramHelper.closeAndClearAddBubblePopup();
                }, true
            );
        });

        /*Bubble löschen und aus dem Html entfernen*/
        $('#deleteBubbleBtn').on('click', function () {
            $('#DeleteBubblePopup').show();
            $('#AddNewBubblePopup').hide();
        });

        $('#deleteConfirmBubbleBtn').on('click', function () {
            const bubbleId = $('#ID').val();

            /* List der aktuellen Bubbles durchgehen und Bubble mit ausgewähltter ID nicht in neue Liste übernehmen */
            const cleanedList: Bubble[] = [];
            if (bubbleId >= 0) {
                for (let i = 0; i < curOrgInfo.Bubbles.length; i++) {
                    if (curOrgInfo.Bubbles[i].id !== +bubbleId) {
                        cleanedList.push(curOrgInfo.Bubbles[i]);
                    }
                }

                curOrgInfo.Bubbles = cleanedList;
                /*Html entfernen*/
                OrganigramHelper.removeHtml(+bubbleId, curOrgInfo);
            }
            $("#addNewBubblePopupForm").trigger('reset');
            $('#DeleteBubblePopup').hide();
        })

        $(`#closeConfirmBubbleBtn`).on('click', function () {
            $("#addNewBubblePopupForm").trigger('reset');
            $('#DeleteBubblePopup').hide();
        });

        $(`#closeAddBubbleBtn`).on('click', function () {
            OrganigramHelper.closeAndClearAddBubblePopup();
        });

        /* Aktuelles Organigram in json-Datei speichern */
        $(`#saveOrganigramBtn`).on(`click`, function () {
            $('#savingIcon').addClass('active');

            /* Speichern der aktuellen Informationen*/
            $.ajax({
                type: "POST",
                url: '/booklet/organigram/SaveOrganigram',
                contentType: "application/json",
                dataType: "json",
                data: JSON.stringify(curOrgInfo),
                success: function (result: object) {
                    $('#savingIcon').removeClass('active');
                    $('#saveSuccessIcon').addClass('active');
                    setTimeout(function () {
                        $('#saveSuccessIcon').removeClass('active');
                    }, 3000);
                },
                error: function (result: object) {
                    $('#savingIcon').removeClass('active');
                    $('#saveErrorIcon').addClass('active');
                    setTimeout(function () {
                        $('#saveErrorIcon').removeClass('active');
                    }, 3000);
                }
            });
        });

        function renderHtml() {
            /*Container, der alles vom Organigram beinhaltet*/
            const rasterContainer = OrganigramHelper.createDivWithClass([rasterContainerCssName]);
            /* Container für Raster und AddRow */
            const outerContent = OrganigramHelper.createDivWithClass(['org-raster-outer']);
            /* Container für Raster-Rows */
            const innerContent = OrganigramHelper.createDivWithClass(['org-raster-inner']);

            /* Container für Raster */
            const rasterContent = OrganigramHelper.createDivWithClass([rasterContentCssName]);
            const addColContainer = OrganigramHelper.createDivWithClass(['org-raster-add-col-content']);
            const addRowContainer = OrganigramHelper.createDivWithClass(['org-raster-add-row-content']);

            /*aktuellen Container leeren*/
            $container.empty();

            /*Event "Neue Spalte hinzufügen"*/
            addColContainer.addEventListener('click', function (e) {
                const $element = $(e.target);
                const $rows = $element.closest(`.${rasterContainerCssName}`).find(`.${rasterRowCssName}`);

                for (let row = 0; row < $rows.length; row++) {
                    const colElement = OrganigramHelper.addCol()
                    $rows[row].appendChild(colElement);
                }
                curOrgInfo.ColCount++;
            });

            /*Event "Neue Reihe hinzufügen"*/
            addRowContainer.addEventListener('click', function (e) {
                const $element = $(e.target);
                const $rasterContent = $element.closest(`.${rasterContainerCssName}`).find(`.${rasterContentCssName}`);
                const currentColCount = $($rasterContent.find(`.${rasterRowCssName}`).get(0)).find(`.${rasterColCssName}`).length;

                const rowElement = OrganigramHelper.addRow(currentColCount);
                $rasterContent.append(rowElement);
                curOrgInfo.RowCount++;
            });

            /*Initialles Raster füllen*/
            for (let row = 0; row < curOrgInfo.RowCount; row++) {

                const rowElement = OrganigramHelper.addRow(curOrgInfo.ColCount);
                rasterContent.appendChild(rowElement);
            }

            /*Grid-Html zusammenstöpseln*/
            innerContent.appendChild(rasterContent)
            innerContent.appendChild(addRowContainer);
            outerContent.appendChild(innerContent);
            outerContent.appendChild(addColContainer);
            rasterContainer.appendChild(outerContent);
            $container.append(rasterContainer);
        }

        /*Funktion zum Server-Aufruf für das Html einer Bubble*/
        function sendAddBubbleRequest(parameters, top, left, onSucccess, onError) {
            dbh_helper.SendGetRequest(
                'GetNewBubbleHtml', 'booklet/organigram',
                parameters,
                null, (response) => {
                    onSucccess(response);
                },
                () => {
                    onError();
                }, true
            );
        }
    }

    public static closeAndClearAddBubblePopup = () => {
        $("#addNewBubblePopupForm").trigger('reset');
        $('#AddNewBubblePopup').hide();
    }

    /*Erstellt ein "div"- Html-Element mit css-Klassen*/
    public static createDivWithClass = (classNames: string[]): HTMLDivElement => {
        const div = document.createElement('div');
        if (classNames && classNames.length > 0) {
            for (let i = 0; i < classNames.length; i++) {
                div.classList.add(classNames[i]);
            }
        }
        return div;
    }

    /*Erstellt eine neue Reihe für das Organigram*/
    public static addRow = (colCount: number): HTMLDivElement => {
        const rowElement = OrganigramHelper.createDivWithClass(['org-raster-row']);
        for (let col = 0; col < colCount; col++) {
            rowElement.appendChild(OrganigramHelper.addCol());
        }
        return rowElement;
    }

    /*Erstellt eine neue Spalte für das Organigram*/
    public static addCol = (): HTMLDivElement => {
        const colElement = OrganigramHelper.createDivWithClass(['org-raster-col']);

        /*Event für Bubble-Hinzufügen-Popup hinzufügen*/
        $(colElement).on('click', function (e) {
            const $this = $(this);
            const posTop = $this.position().top;
            const posLeft = $this.position().left;
            /*Setzen der Hidden-Values für die Position der neuen Bubble*/
            $("#Top").val(posTop);
            $("#Left").val(posLeft);

            /*New und Edit teilen sich einen View -> View für richtige Action anpassen*/
            $('#AddNewBubblePopup h3').text('Neue Bubble hinzufügen');
            $(`#addBubbleBtn`).removeClass('hide');
            $(`#editBubbleBtn`).addClass('hide');
            $(`#deleteBubbleBtn`).addClass('hide');

            $('#AddNewBubblePopup').show();
        });

        return colElement;
    };

    /* Erstelle neue Bubble, setze Click-Events und Verhalten beim "Verschieben" im Raster */
    public static createNewHtmlBubble = (response: string, organigramInfo: OrganigramInfos = null, id, top: number = null, left: number = null) => {
        const outerBubble = OrganigramHelper.createDivWithClass(['outerBubble']);
        outerBubble.style.top = `${top ? top : 0}px`;
        outerBubble.style.left = `${left ? left : 0}px`;

        /*Neue Nummer für Bubble-id bestimmen
                     * .map liefert ein neues Array (hier: mit den aktuellen Ids der Bubbles)
                     * ...[a,b,c] -> Spread-Operator, Elemente des Arrays werden als einzelne Elemente zurückgegeben
                     */
        let bubbleId: number = id;
        if (bubbleId || bubbleId === 0) {
            outerBubble.dataset.bubbleid = `${bubbleId}`;
        }

        outerBubble.innerHTML = response;

        /*Schaltfläche zum Verbinden der Bubbles hinzufügen*/
        const addLineBtn = OrganigramHelper.createDivWithClass(['add-line-btn']);
        addLineBtn.title = 'Bubble für Linie hinzufügen';
        addLineBtn.innerHTML = "<span>+</span>";
        outerBubble.append(addLineBtn);

        $(addLineBtn).on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            OrganigramHelper.handeLineStatusOnClick($(this), organigramInfo);
        });

        /* Variable zum Verhindern dass das Klick-Event direkt nach dem Drop der Bubble getriggert wird */
        let lockClickEvent = false;

        /*zuweisen der Verschiebe-Eigenschaften:
         * bewegt sich nur um 75px, 
         * kann das Eltern-Element nicht verlassen, 
         * Container scrollt beim Verschieben nicht mit*/
        //@ts-ignore
        $(outerBubble).draggable({
            grid: [OrganigramHelper.GridTileSize, OrganigramHelper.GridTileSize],
            containment: "parent",
            scroll: false,
            stop: function (event, ui) {
                /* Verhindern, dass das Klick-Event nach dem Drop gefeuert wird*/
                lockClickEvent = true;

                /*Neue Position der Bubble auch im Data-Objekt setzen */
                const element = ui.helper;
                const id = $(element).data('bubbleid');

                const curBubble: Bubble = organigramInfo.Bubbles.find(b => b.id === id);

                if (!curBubble) {
                    return;
                }

                const position = ui.position;
                curBubble.top = +position.top.toString().split('.')[0];
                curBubble.left = +position.left.toString().split('.')[0];

                const parentBubbles: Bubble[] = OrganigramHelper.getParentsBubbles(curBubble, organigramInfo);

                /*Render Linien zu den Children neu*/
                OrganigramHelper.renderLine(curBubble, organigramInfo, 'org-raster-content');

                /*Render Linien zu dem Parent neu*/
                if (parentBubbles.length > 0) {
                    for (let i = 0; i < parentBubbles.length; i++) {
                        OrganigramHelper.renderLine(parentBubbles[i], organigramInfo, 'org-raster-content');
                    }
                }

                /* Klick-Event nach 0.1s wieder freigeben */
                setTimeout(() => {
                    lockClickEvent = false;
                }, 100);
            }
        });

        /*Edit-Bubble-Popup öffnen*/
        $(outerBubble).on('click', function (e) {
            /* Wenn Klick nach Drop noch nicht freigegeben wurde, wird der Klick nicht ausgeführt */
            if (lockClickEvent) {
                return;
            }

            const $this = $(this);
            /*Laden der Bubble-Informationen*/
            const id = $this.data('bubbleid');
            const curBubble: Bubble = organigramInfo.Bubbles.find(b => b.id === id) ?? null;

            /*ajax-Call für Edit-popup*/
            if (curBubble != null) {
                $('#ID').val(id);
                $('#Top').val(curBubble.top);
                $('#Left').val(curBubble.left);
                $('#Headline').val(curBubble.headline);
                $('#Info').val(curBubble.info);
                $('#Color').val(curBubble.color);
                $('#IsSmallBubble').prop('checked', curBubble.isSmall)

                /* Telerik-Multiselect füllen*/
                const adressenMultiselect = $("#Adressen").data("kendoMultiSelect");
                adressenMultiselect.value(curBubble.users);

                /*New und Edit teilen sich einen View -> View für richtige Action anpassen*/
                $('#AddNewBubblePopup h3').text('Bubble bearbeiten');
                $(`#addBubbleBtn`).addClass('hide');
                $(`#editBubbleBtn`).removeClass('hide');
                $(`#deleteBubbleBtn`).removeClass('hide');

                $('#AddNewBubblePopup').show();
            }
        });


        return outerBubble;
    }

    /*Info-Array für die zu verbindenden Bubbles*/
    public static curLineElements: number[] = [];

    public static handeLineStatusOnClick($element: JQuery<HTMLElement>, organigramInfo: OrganigramInfos) {
        let clearList = $element === null || $element.length === 0 || !$element.hasClass('add-line-btn');
        if (!clearList) {
            const $outerBubble = $element.closest('.outerBubble');
            clearList = $outerBubble.length < 1;
            if (!clearList) {
                const id = $outerBubble.data('bubbleid');

                if (OrganigramHelper.curLineElements.length === 0) {
                    /* Parent für Linie wurde ausgewählt -> Bubble-ID merken */
                    OrganigramHelper.curLineElements.push(id);
                    $outerBubble.addClass('line-select-active');
                } else if (OrganigramHelper.curLineElements.length === 1) {
                    /* Child für Linie wurde ausgewählt */

                    /* Prüfen, ob nicht das gleiche Element ausgewählt wurde, welches schon in der Merk-Liste enthalten ist*/
                    clearList = OrganigramHelper.curLineElements[0] === id;
                    if (!clearList) {
                        OrganigramHelper.curLineElements.push(id);

                        const supposedParent: Bubble = organigramInfo.Bubbles.find(b => b.id === OrganigramHelper.curLineElements[0]);
                        const supposedChild: Bubble = organigramInfo.Bubbles.find(b => b.id === OrganigramHelper.curLineElements[1]);

                        let parent: Bubble = supposedParent;
                        let child: Bubble = supposedChild;

                        /* Anhand des Top-Wertes ermitteln wer der eigentliche Parent ist */
                        //if (supposedParent.top > supposedChild.top) {
                        //    console.log("child is parent");
                        //    const tempBubble: Bubble = parent;
                        //    parent = child;
                        //    child = tempBubble;
                        //}

                        const parentIndexInChild: number = child.children.indexOf(parent.id);

                        /* Wenn das Child den Parent enthält, dann wird die Zuweisung entfernt (sonst wird Bubble eigener Großvater) */
                        if (parentIndexInChild >= 0) {
                            child.children.splice(parentIndexInChild, 1);
                            OrganigramHelper.renderLine(child, organigramInfo, 'org-raster-content');
                        } else {
                            /*Wenn das ausgewählte Child bereits in der Liste des Parents ist, wird die Zuweisung entfernt*/
                            const childLineAlreadyExistsIndex: number = parent.children.indexOf(child.id);
                            if (childLineAlreadyExistsIndex < 0) {
                                /* Linie hinzufügen */
                                parent.children.push(OrganigramHelper.curLineElements[1]);
                            } else {
                                /* Linie entfernen*/
                                parent.children.splice(childLineAlreadyExistsIndex, 1);
                            }
                            OrganigramHelper.renderLine(parent, organigramInfo, 'org-raster-content');
                        }

                        clearList = true;
                    }
                }
                else {
                    clearList = true;
                }
            }
        }

        /* Leeren der Liste für neue Linienverbindung und selektierte Bubble (für Linie) clearen2g */
        if (clearList) {
            OrganigramHelper.curLineElements = [];
            $('.outerBubble').removeClass("line-select-active");
        }
    }

    public static renderLine(parent: Bubble, organigramInfo: OrganigramInfos, rasterContentCssName: string) {
        /* Breitenwert des HTML-Elements, später wichtig für die Linien */
        const bubbleSizeInPx: number = 150;
        const halfBubbleWidth: number = (bubbleSizeInPx / 2);
        const firstLineHeight: number = 80;
        const smallBubbleOffset: number = 40;
        const generalLineClass: string = 'bubble-lines';
        const verticalLineClass: string = 'bubble-vertical-line';
        const horizontalLineClass: string = 'bubble-horizontal-line';

        /*Alle bisherigen Linien des Parents enfernen*/
        const $curLineElements = $(`.${generalLineClass}.${parent.id}`);
        for (let i = 0; i < $curLineElements.length; i++) {
            $($curLineElements[i]).remove();
        }

        /* Wenn keine Children vorhanden sind, muss keine Linie gezeichnet werden*/
        if (parent.children.length === 0) {
            return;
        }

        /* Datenstrukturen für die Positionen der Children */
        const children: Bubble[] = [];

        /* Kinder-Bubbles ermitteln  */
        for (let i = 0; i < parent.children.length; i++) {
            const child: Bubble = organigramInfo.Bubbles.find(b => b.id === parent.children[i]);
            children.push(child);
        }

        let horizontalLineLength: number = 0;
        let maxLeftOfChildren: number = 0;
        let minLeftOfChildren: number = Number.MAX_SAFE_INTEGER;

        /*Berechnen der Länge für horizontale Linie*/
        for (let i = 0; i < children.length; i++) {
            if (children[i].left < minLeftOfChildren) {
                minLeftOfChildren = children[i].left;
            }
            if (children[i].left > maxLeftOfChildren) {
                maxLeftOfChildren = children[i].left;
            }
        }

        horizontalLineLength = maxLeftOfChildren - minLeftOfChildren;

        /* Berechnung des Top-Wertes: Position des Parent + Höhe der "outerBubble" - 40 (damit die Linie auch bei kleinen Bubbles ansetzt)*/
        const firstLineTopPosition: number = parent.top + (bubbleSizeInPx - smallBubbleOffset);
        /* Mittige Positionierung der Linie an der Eltern-Bubble */
        const firstLineLeftPosition: number = parent.left + halfBubbleWidth;

        /*### Erstelle erste vertikale Linie (von Parent zur horizontal Linie) ###*/
        const firstVerticalLine = OrganigramHelper.createDivWithClass([generalLineClass, verticalLineClass, 'first', parent.id.toString()])
        /* Setzen des Top-Werts*/
        firstVerticalLine.style.top = `${firstLineTopPosition}px`;
        /* Setzen des Left-Werts */
        firstVerticalLine.style.left = `${firstLineLeftPosition}px`;
        /*Höhe der Linie setzen*/
        firstVerticalLine.style.height = `${firstLineHeight}px`;
        /*Linie zum Html hinzufügen*/
        $(`.${rasterContentCssName}`).append(firstVerticalLine);

        /*### Erstelle horizontale Linie ###*/
        const horizontalLine = OrganigramHelper.createDivWithClass([generalLineClass, horizontalLineClass, parent.id.toString()])

        /* Berechne Wert für horizontale Linie */
        let horizontalLeftValue: number = 0;

        /* Nur ein Child oder alle Childs untereinander*/
        if (horizontalLineLength === 0) {
            /* Prüfen, ob Child/-ren link oder rechts vom Parent lieggen */
            if (maxLeftOfChildren < firstLineLeftPosition) {
                /* Child ist links von Parent*/
                /* Horizontale Linie startet bei linkstem Child - halbe Bubblebreite wird hinzuaddiert, 
                 * damit die Linie mittig des Child startet*/
                horizontalLeftValue = maxLeftOfChildren + halfBubbleWidth;
                /* Länge ist die Differenz aus vertikaler Linie und linksten Child, verkürzen um halbe 
                 * Bubble-Breite und um 4px erhöhen (Breite der vertikalten Linie, damit diese bündig sind)*/
                horizontalLineLength = firstLineLeftPosition - maxLeftOfChildren - halfBubbleWidth + 4;
            } else {
                /* Child ist rechts von Parent*/
                /* Horizontale Linie startet bei erster vertikaler Linie*/
                horizontalLeftValue = firstLineLeftPosition;
                /* Länge der horizontalen Linie ergibt sich aus der Differenz des rechtesten 
                 * Child und der ersten vertikalen Linie - halbe Bubblebreite wird hinzuaddiert 
                 * damit die horizontale Linie mittig abschließt*/
                horizontalLineLength = maxLeftOfChildren - firstLineLeftPosition + halfBubbleWidth;
            }
        }
        else {
            /* Prüfen ob Parent-Position  ausserhalb des Min- und Max-Left-Werts der Kinder liegt*/
            if (parent.left < minLeftOfChildren || parent.left > maxLeftOfChildren) {
                if (parent.left < minLeftOfChildren) {
                    /*Parent liegt links der Children*/
                    horizontalLeftValue = parent.left + halfBubbleWidth;
                    horizontalLineLength = maxLeftOfChildren - horizontalLeftValue + halfBubbleWidth;
                } else {
                    /*Parent liegt rechts der Children*/
                    horizontalLeftValue = minLeftOfChildren + halfBubbleWidth;
                    horizontalLineLength = parent.left - horizontalLeftValue + halfBubbleWidth + 4;
                }
            } else {
                /*Wert für Left startet beim ganz linken Child in der Mitte*/
                horizontalLeftValue = minLeftOfChildren + halfBubbleWidth;
            }
        }

        const positionOfEndOfVerticalLine: number = firstLineTopPosition + firstLineHeight;

        /* Top-Position: Dort wo die erste vertikale Linie endet*/
        horizontalLine.style.top = `${positionOfEndOfVerticalLine}px`;
        horizontalLine.style.left = `${horizontalLeftValue}px`;
        horizontalLine.style.width = `${horizontalLineLength}px`;

        $(`.${rasterContentCssName}`).append(horizontalLine);

        /*### Erstelle zweite vertikale Linien (von horizontal Linie zu Children) ###*/
        for (let i = 0; i < children.length; i++) {
            const secondVerticalLine = OrganigramHelper.createDivWithClass([generalLineClass, verticalLineClass, 'second', parent.id.toString()])
            /* Setzen des Top-Werts*/
            secondVerticalLine.style.top = `${positionOfEndOfVerticalLine}px`;
            /* Setzen des Left-Werts (mittig der Bubble) */
            secondVerticalLine.style.left = `${children[i].left + halfBubbleWidth}px`;
            /*Höhe der Linie setzen -> + 40, für kleine Bubbles*/
            secondVerticalLine.style.height = `${children[i].top - positionOfEndOfVerticalLine + smallBubbleOffset}px`;
            /*Linie zum Html hinzufügen*/
            $(`.${rasterContentCssName}`).append(secondVerticalLine);
        }
    }

    public static removeHtml(bubbleId: number, organigramInfo: OrganigramInfos) {
        /* Linien zu Parents entfernen */
        for (let i = 0; i < organigramInfo.Bubbles.length; i++) {
            const childrenInBubble = organigramInfo.Bubbles[i].children;
            const childIndex = childrenInBubble.indexOf(bubbleId);
            if (childIndex >= 0) {
                childrenInBubble.splice(childIndex, 1);
                OrganigramHelper.renderLine(organigramInfo.Bubbles[i], organigramInfo, 'org-raster-content');
            }
        }

        /* Linien zu Kindern entfernen */
        const $lineToDeleteElements = $(`.bubble-lines.${bubbleId}`);
        for (let i = 0; i < $lineToDeleteElements.length; i++) {
            $($lineToDeleteElements[i]).remove();
        }
        $(`.outerBubble[data-bubbleid='${bubbleId}']`).remove();
    }

    /*Erstellt bubble-Info-Objekt für die Organigram-Info*/
    public static createBubbleInfoItem(parameters: any[], id: number) {
        const bubble = new Bubble();
        bubble.id = id;
        bubble.users = [];
        bubble.children = [];

        /* Fix für das Problem, das n´bei den Parametern für Checkboxen bei gecheckter Box beide Werte (true, false) mitgeliefert werden
         * Bei der Auswertung wird dann der true-Wert überschrieben*/
        let bubbleSizeSet = false;

        for (let i = 0; i < parameters.length; i++) {
            switch (parameters[i][0]) {
                case 'Top':
                    /* Nachkommastellen vermeiden mit split (manchmal werden statt ganze Werte Gleitkommazahlen übergeben 
                     * (z.b. statt 150 -> 150.000000121 */
                    bubble.top = +(parameters[i][1].split('.')[0]);
                    break;
                case 'Left':
                    bubble.left = +(parameters[i][1].split('.')[0]);
                    break;
                case 'Headline':
                    bubble.headline = decodeURIComponent(parameters[i][1]);
                    break;
                case 'Info':
                    bubble.info = decodeURIComponent(parameters[i][1]);
                    break;
                case 'Adressen':
                    bubble.users.push(parameters[i][1]);
                    break;
                case 'Color':
                    bubble.color = decodeURIComponent(parameters[i][1]);
                    break;
                case 'IsSmallBubble':
                    if (!bubbleSizeSet) {
                        bubbleSizeSet = parameters[i][1] === "true";
                        bubble.isSmall = parameters[i][1] === "true";
                    }
                    break;
            }
        }
        return bubble;
    }

    /*Anpassen einer Bubble im Data-Objekt  */
    public static editBubbleInfoItem(bubbles: Bubble[], id: number, parameters: any[]) {
        for (let i = 0; i < bubbles.length; i++) {
            if (bubbles[i].id !== id) {
                continue;
            }

            const editedBubble = OrganigramHelper.createBubbleInfoItem(parameters, id);
            bubbles[i] = editedBubble;

            break;
        }
    }

    /*Prüfen ob Objekt ein OrganigramInfos-Objekt ist*/
    public static checkOrganigramIsFromJsonFile(objFromJson: any): boolean {
        /*Wenn das Objekt die Properties der Klasse "OrganigramInfos" enthält, besitzt es die Klasse*/
        return objFromJson && 'RowCount' in objFromJson && 'ColCount' in objFromJson && 'Bubbles' in objFromJson;
    }

    /* Ermittle die Parents der Bubble */
    public static getParentsBubbles(child: Bubble, organigramInfo: OrganigramInfos): Bubble[] {
        const parentBubbles: Bubble[] = [];

        for (let i = 0; i < organigramInfo.Bubbles.length; i++) {
            if (organigramInfo.Bubbles[i].children.indexOf(child.id) >= 0) {
                parentBubbles.push(organigramInfo.Bubbles[i]);
            }
        }

        return parentBubbles;
    }
}


export class OrganigramInfos {
    constructor(rowCount, colCount, bubbles) {
        this.RowCount = rowCount;
        this.ColCount = colCount;
        this.Bubbles = bubbles;
    }

    RowCount: number;
    ColCount: number;
    Bubbles: Bubble[];
}

class Bubble {
    id: number;
    top: number;
    left: number;
    headline: string;
    info: string;
    color: string;
    users?: any[];
    children?: number[];
    isSmall: boolean;
}


   //public BuildOrganigramRecursive = (organigram: LevelInfo, $parent: JQuery<HTMLElement>, isRoot = false, addPaddingLeft: number = null, firstLevelFlex = false) => {
    //    const htmlLevel = document.createElement('div');
    //    htmlLevel.classList.add('organigram-level');
    //    htmlLevel.style.zIndex = `${organigram.level}`;

    //    let gridTemplateColumn = '';

    //    organigram.bubbles.forEach((bubble: Bubble) => {
    //        const htmlOuterBubble = document.createElement('div');
    //        const htmlInnerBubble = document.createElement('div');

    //        htmlOuterBubble.classList.add('organigram-outer-bubble');
    //        htmlInnerBubble.classList.add('organigram-inner-bubble');

    //        /* Bilder (+ Link, falls vorhanden) für zugewiesene User erstellen */
    //        const imgContainer = document.createElement('div');
    //        imgContainer.classList.add('organigram-inner-bubble-images')
    //        if (bubble.users) {
    //            for (let i = 0; i < bubble.users.length; i++) {
    //                if (!bubble.users[i].img) {
    //                    break;
    //                }
    //                const imgElement = bubble.users[i].link && bubble.users[i].link.length > 0 ? document.createElement('a') : document.createElement('span');
    //                if (bubble.users[i].link && bubble.users[i].link.length) {
    //                    imgElement.setAttribute('href', bubble.users[i].link);
    //                    imgElement.setAttribute('target', '_blank');
    //                    imgElement.setAttribute('alt', 'profil image');

    //                    if (bubble.users[i].name) {
    //                        imgElement.setAttribute('title', bubble.users[i].name);
    //                        imgElement.setAttribute('alt', bubble.users[i].name);
    //                    }
    //                }

    //                const userImg = document.createElement('img');
    //                userImg.setAttribute('src', bubble.users[i].img);

    //                /*Größe der Bilder bei zu hoher Anzahl verringern*/
    //                const smallerImgWidth = 50;
    //                if (bubble.users.length > 2) {
    //                    userImg.style.width = `${smallerImgWidth}px`;
    //                    userImg.style.height = `${smallerImgWidth}px`;
    //                    userImg.style.minWidth = `${smallerImgWidth}px`;
    //                    userImg.style.minHeight = `${smallerImgWidth}px`;
    //                    imgElement.style.margin = '0 -10px 0 0';
    //                }

    //                imgElement.append(userImg);
    //                imgContainer.append(imgElement);
    //            }
    //        }
    //        htmlInnerBubble.append(imgContainer);

    //        if (bubble.extrarange) {
    //            htmlInnerBubble.style.top = `256px`;
    //            htmlInnerBubble.classList.add('extra-range');
    //        }

    //        if (bubble.name) {
    //            const bubbleName = bubble.link && bubble.link.length > 0 ? document.createElement('a') : document.createElement('span');

    //            if (bubble.link && bubble.link.length > 0) {
    //                bubbleName.setAttribute('href', bubble.link);
    //                bubbleName.setAttribute('target', '_blank');
    //            }

    //            bubbleName.append(bubble.name);
    //            htmlInnerBubble.append(bubbleName);
    //        }
    //        if (bubble.info) {
    //            const infoSpan = document.createElement('span');
    //            infoSpan.classList.add('organigram-inner-bubble-info');
    //            infoSpan.innerHTML = bubble.info;
    //            htmlInnerBubble.append(infoSpan);
    //        } else if (!organigram.verticaly) {
    //            imgContainer.style.marginBottom = '32px';
    //        }

    //        if (bubble.color) {
    //            htmlInnerBubble.style.background = bubble.color;
    //        }

    //        htmlOuterBubble.style.zIndex = `${organigram.level}`;



    //        /*Nur wichtig, wenn "firstLevelFlex" nicht gesetzt ist: Damit die unteren Elemente nicht 
    //         * teilweise von den oberen Elementen überdeckt werden (da diese später im HTML erscheinen 
    //         * und somit für den Browser darüber liegen)
    //         * erhalten Bubbles mit Kinder-Elementen ein höheren z-Index*/
    //        if (bubble.nextLevel && bubble.nextLevel.bubbles?.length > 0) {
    //            htmlOuterBubble.style.zIndex = '100';
    //        }

    //        htmlOuterBubble.append(htmlInnerBubble);

    //        /*Bubbles in vertikaler Reihe haben andere Style-Eigenschaften*/
    //        if (organigram.verticaly) {
    //            htmlInnerBubble.classList.add('vertical-bubble');
    //        }
    //        else if (bubble.nextLevel && bubble.nextLevel?.bubbles?.length > 0 && !bubble.nextLevel.verticaly) {
    //            /*Verbindungslinien hinzufügen*/
    //            const lineDown = document.createElement('div');
    //            lineDown.classList.add('line');
    //            /*Abstand für Bilder und Text-Info*/
    //            htmlInnerBubble.style.marginBottom = '50px';
    //            htmlOuterBubble.append(lineDown);

    //            const lineVertical = document.createElement('div');
    //            lineVertical.classList.add('lineV');

    //            //lineVertical.style.width = `${150 * (bubble.nextLevel?.bubbles?.length > 0 ? bubble.nextLevel?.bubbles?.length - 1: 0)}px`;
    //            htmlOuterBubble.append(lineVertical);
    //        }

    //        htmlLevel.append(htmlOuterBubble);

    //        if (bubble.nextLevel) {
    //            this.BuildOrganigramRecursive(bubble.nextLevel, $(htmlOuterBubble));
    //        }

    //        if (isRoot && firstLevelFlex) {
    //            $(htmlLevel).css("display", "flex");
    //        }
    //        else {
    //            gridTemplateColumn += ` ${(100 / organigram.bubbles.length)}%`;
    //        }
    //    })

    //    htmlLevel.style.gridTemplateColumns = gridTemplateColumn;
    //    if (!isRoot) {
    //    }

    //    /*Vertikale Bubbles einstellen*/
    //    if (organigram.verticaly) {
    //        htmlLevel.classList.add('vertical');
    //    }

    //    if ($parent.length > 0) {
    //        $parent.append(htmlLevel);
    //    }

    //    /*Anpassungen, nachdem alle Elemente hinzugefügt wurden*/
    //    if (isRoot) {
    //        /* Bei nicht sichtbaren Elementen kann mittels Offset kein Wert bestimmt werden. 
    //         * Deswegen müssen entsprechende Elemente kurzzeitig sichtbar gemacht werden*/
    //        const $contentTabs = $('.content-content-tab');
    //        $contentTabs.css('position', 'absolute');
    //        $contentTabs.css('display', 'block');

    //        const $verticalLines = $parent.find('.lineV');
    //        /*Berechnung der Breiten der vertikalen Linien*/
    //        for (let i = 0; i < $verticalLines.length; i++) {
    //            const $curLine = $($verticalLines[i]);
    //            const $childLevel = $curLine.parent().find('> .organigram-level');

    //            if ($childLevel.length > 0) {
    //                const $childBubbles = $childLevel.find('> .organigram-outer-bubble');
    //                /*"left-Position" der letzten Kind-Bubble - "left-Position" der 1. Kind-Bubble ergibt die Breite der Linie*/
    //                const vLineWidth = $($childBubbles[$childBubbles.length - 1]).offset().left - $($childBubbles[0]).offset().left;
    //                $curLine.css('width', `${vLineWidth}px`);

    //                $childBubbles.each(function () {
    //                    const $outerBubble = $(this);
    //                    /*Child-Bubbles erhalten kleine Linie nach oben*/
    //                    $outerBubble.addClass('lineTop');
    //                    /*Längere Linie bei Elementen, deren Kinder extra-range haben*/
    //                    if ($outerBubble.find("> .organigram-inner-bubble.extra-range").length > 0) {
    //                        $outerBubble.addClass('extra-range');
    //                    }
    //                });
    //            }
    //        }

    //        if (addPaddingLeft) {
    //            const $elementToShift = $parent.find('> .organigram-level').find('> .organigram-outer-bubble').find('> .organigram-level');
    //            const $vLineToShift = $parent.find('> .organigram-level').find('> .organigram-outer-bubble').find('> .lineV');

    //            $elementToShift.css('padding-left', `${addPaddingLeft}px`);
    //            $vLineToShift.css('margin-left', `${addPaddingLeft}px`);
    //        }

    //        $contentTabs.css('display', '');
    //        $contentTabs.css('position', '');
    //    }
    //}

//class LevelInfo {
//    level: number;
//    bubbles: Bubble[];
//    verticaly: boolean;
//}

//class User {
//    name: string;
//    link: string;
//    img: string;
//}

//class Bubble {
//    name: string;
//    users?: User[];
//    link: string;
//    info: string;
//    color: string;
//    extrarange?: boolean;
//    nextLevel: LevelInfo;
//}

